(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["property-valuation-wizard"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-valuation-wizard]').forEach((wizard) => {
    const steps = Array.from(wizard.querySelectorAll('[data-step]'));
    if (!steps.length) return;
    let current = 0;
    const next = wizard.querySelector('[data-next]');
    const back = wizard.querySelector('[data-back]');
    const submit = wizard.querySelector('[data-submit]');
    const bar = wizard.querySelector('[data-progress-bar]');
    const percent = wizard.querySelector('[data-progress-percent]');
    const label = wizard.querySelector('[data-progress-label]');
    const notice = wizard.querySelector('[data-notice]');
    const stepWord = label.textContent.replace(/\s*\d+\s*\/\s*\d+.*/, '').trim() || 'Passaggio';

    const render = () => {
      steps.forEach((step, index) => step.classList.toggle('is-active', index === current));
      const progress = Math.round(((current + 1) / steps.length) * 100);
      bar.style.width = `${progress}%`;
      percent.textContent = `${progress}%`;
      label.textContent = `${stepWord} ${current + 1} / ${steps.length}`;
      back.disabled = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      notice.textContent = '';
    };

    const validStep = () => {
      const required = Array.from(steps[current].querySelectorAll('[required]'));
      const invalid = required.find((field) => !field.checkValidity());
      if (invalid) {
        invalid.reportValidity();
        notice.textContent = 'Completa i campi richiesti per continuare.';
        return false;
      }
      return true;
    };

    next.addEventListener('click', () => {
      if (!validStep()) return;
      current = Math.min(current + 1, steps.length - 1);
      render();
      wizard.querySelector('.pvw__panel').scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    back.addEventListener('click', () => {
      current = Math.max(current - 1, 0);
      render();
    });
    render();
  });

  } catch(e) { console.error(e); }
})();
})();
